require('./bootstrap');

const moment = require('moment');

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('#popup');
    const closeButton = document.querySelector('#popup-close');
    const manifestButton = document.querySelector('a[href="https://bolsarosa.com/sublanding/manifiesto"]');

    // Evitar mostrar el popup en la ruta del manifiesto y en todas las ferias
    const currentUrl = window.location.href;
    if (currentUrl.includes('/sublanding/manifiesto') || currentUrl.includes('/ferias/')) {
        if (popup) {
            popup.classList.add('hidden');
        }
        return; // Salir del script, ya que no queremos manejar el popup en esta página
    }

    if (popup && closeButton) {
        closeButton.addEventListener('click', () => {
            // Establecer la próxima fecha de aparición en 3 días
            const threeDaysLater = new Date();
            threeDaysLater.setDate(threeDaysLater.getDate() + 3);
            localStorage.setItem('popupLastSeen', threeDaysLater.toString());
            popup.classList.add('hidden');
        });

        // Si se hace clic en el botón de "Ir al manifiesto"
        if (manifestButton) {
            manifestButton.addEventListener('click', () => {
                const threeDaysLater = new Date();
                threeDaysLater.setDate(threeDaysLater.getDate() + 3);
                localStorage.setItem('popupLastSeen', threeDaysLater.toString());
            });
        }

        // Mostrar el popup solo si han pasado más de 3 días desde la última vez que se vio
        const popupVisibleDays = 3; // Número de días que el popup debe ser visible
        const lastSeen = localStorage.getItem('popupLastSeen');
        const now = new Date();

        if (!lastSeen || (now - new Date(lastSeen)) / (1000 * 60 * 60 * 24) > popupVisibleDays) {
            popup.classList.remove('hidden');
        }
    }
});


